import { IonContent, IonPage, IonHeader,IonToolbar, IonButtons,IonBackButton,IonTitle} from '@ionic/react';
//import WaveTabs from '../components/WaveTabs';
import PageTitle from '../components/PageTitle';
//import TournamentSearch from '../components/TournamentSearch';
import TeamTournamentSearch from '../components/TeamTournamentSearch';
import EventSearch from 'components/EventSearch';
import { RouteComponentProps } from 'react-router';
import CommonHeader from 'components/CommonHeader';
import TeamsWaveTabs from 'components/TeamsWaveTabs';
import TeamMatchSearch from 'components/TeamMatchSearch';


const TeamSearchPage: React.FC<RouteComponentProps> = () => {
  return (
    <IonPage>
       <IonHeader>
        <IonToolbar>
          <IonButtons slot="start">
            <IonBackButton style={{display:"block"}} />
          </IonButtons>
          {/* <IonTitle color="main-text">Search</IonTitle> */}
        </IonToolbar>
      </IonHeader>
      {/* <CommonHeader title = {`Search`}></CommonHeader> */}
      <IonContent fullscreen>
        <TeamsWaveTabs 
          leftTitle="Team Match" 
          rightTitle="Team Tournament"
          //centerTitle="Event" 
          leftComponent={<TeamMatchSearch />} 
          //rightComponent={<TournamentSearch />}
          rightComponent={
          <div style={{ width: '100%' }}>
            <TeamTournamentSearch />
          </div>
        }
          //centerComponent={<EventSearch />}
          color='accent-two'
          
        >
          <PageTitle color="main">Search Team</PageTitle>
        </TeamsWaveTabs>
      </IonContent>
    </IonPage>
  );
};


export default TeamSearchPage;


